import axios from "axios";

const BASE = "/api/events";

// Small service wrapper around the Events endpoint, used to feature upcoming
// events on the Resources page alongside articles/videos/courses/etc.
export const EventsApi = {
  async upcoming() {
    const res = await axios.get(`${BASE}/upcoming/`, { withCredentials: true });
    return res.data;
  },
};
